import React from 'react';
import ReactPlayer, {ReactPlayerProps} from 'react-player';
import LazyReactPlayer from 'react-player/lazy';

export interface VideoPlayerComponentProps extends ReactPlayerProps {
  /** If true, uses lazy-loading for the player */
  lazyLoad?: boolean;
}

const VideoPlayer: React.FC<VideoPlayerComponentProps> = ({
  width = '100%',
  height = '100%',
  lazyLoad = true,
  url = 'https://www.youtube.com/watch?v=5-XwPX0Uwnc&pp=ygUOcGFsZXN0aW5lIGtpZHM%3D',
  controls = true,
  ...otherProps
}) => {
  const playerProps: ReactPlayerProps = {
    url,
    width,
    height,
    controls,
    ...otherProps,
  };

  return lazyLoad ? (
    <LazyReactPlayer {...playerProps} />
  ) : (
    <ReactPlayer {...playerProps} />
  );
};

export default VideoPlayer;
